import { render, staticRenderFns } from "./delete-prompt.vue?vue&type=template&id=05c00120&scoped=true&"
import script from "./delete-prompt.vue?vue&type=script&lang=js&"
export * from "./delete-prompt.vue?vue&type=script&lang=js&"
import style0 from "./delete-prompt.vue?vue&type=style&index=0&id=05c00120&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c00120",
  null
  
)

export default component.exports